import React from 'react';
import styles from './PriceSection.module.scss';
import womanIllustration from '../../assets/img/woman-illustration.png';

const index = () => {
  return (
    <div id="price" className={styles.container}>
      <h1> Beauty Menu</h1>
      <h2>Bellezza, qualità e risultati visibili</h2>
      <div className={styles.section}>
        <div className={styles.menu}>
          <div className={styles.body}>
            <h3>HYDRAFACIAL</h3>
            <ul>
              <li>Basic — €110</li>
              <li>Advanced (pulizia profonda pori) — €150</li>
              <li>Deluxe (booster + linfodrenaggio) — €180</li>
              <li>Platinum (LED + massaggio) — €220</li>
            </ul>
            <p>Pelle pulita, luminosa e idratata già dalla prima seduta</p>
          </div>
          <div className={styles.body}>
            <h3>TRATTAMENTI VISO</h3>
            <ul>
              <li>Pulizia viso profonda — €120</li>
              <li>Idratazione intensiva — €110</li>
              <li>Anti-age lifting — €140</li>
              <li>Glow skin — €130</li>
              <li>Peeling chimico — €130–160</li>
            </ul>
          </div>
          <div className={styles.body}>
            <h3>EXTENSION CIGLIA</h3>
            <ul>
              <li>Naturale (1D) — €85</li>
              <li>Volume leggero (2D) — €95</li>
              <li>Volume (3D) — €115</li>
              <li>Volume russo — €140</li>
              <li>Mega volume — €160</li>
              <li>Refill — €70–80</li>
            </ul>
            <p>Sguardo intenso, elegante e su misura</p>
          </div>
          <div className={styles.body}>
            <h3>LAMINAZIONE</h3>
            <ul>
              <li>Ciglia — €80</li>
              <li>Sopracciglia — €70</li>
              <li>Combo — €130</li>
            </ul>
            <p>Effetto naturale, ordinato e definito</p>
          </div>
          <div className={styles.body}>
            <h3>MASSAGGI CORPO</h3>
            <ul>
              <li>Rilassante — €90</li>
              <li>Decontratturante — €100</li>
              <li>Linfodrenante — €100</li>
              <li>Anticellulite — €110</li>
              <li>Modellante — €120</li>
            </ul>
          </div>
          <div className={styles.body}>
            <h3>ENDOSFERA THERAPY</h3>
            <ul>
              <li>1 seduta — €90</li>
              <li>5 sedute — €425</li>
              <li>8 sedute — €640</li>
              <li>10 sedute — €750</li>
            </ul>
            <p>Risultati visibili già dalle prime sedute Consigliato ciclo 8–10 trattamenti</p>
          </div>
        </div>
        <img src={womanIllustration} alt="decorazione" className={styles.image} />
      </div>
    </div>
  );
};

export default index;
